<template>
  <base-slide-over ref="slideOver" title="Merge Users">
    <div class="tw-py-3 tw-px-6">
      <div v-if="member1" class="tw-flex tw-items-center">
        <base-field title="Patient 1">
          <div class="tw-flex tw-items-center">
            {{ member1.fullName }}
            <base-icon color="red" @click="member1 = null" class="tw-ml-1">
              <x-icon class="tw-h-5 tw-w-5" />
            </base-icon>
          </div>
        </base-field>
      </div>
      <member-search label="Patient 1" :business-id="businessId" @memberSelected="member1 = $event" v-else />
      <div class="tw-my-5 tw-text-gray-600">into</div>

      <div v-if="member2" class="tw-flex tw-items-center">
        <base-field title="Patient 2">
          <div class="tw-flex tw-items-center">
            {{ member2.fullName }}
            <base-icon color="red" @click="member2 = null" class="tw-ml-1">
              <x-icon class="tw-h-5 tw-w-5" />
            </base-icon>
          </div>
        </base-field>
      </div>
      <member-search label="Patient 2" :business-id="businessId" @memberSelected="member2 = $event" v-else />
      <div class="tw-mt-8 tw-text-gray-800">
        This will merge records from patient 1 into patient 2. Patient 1 will be deleted and all current plans and prescriptions will be under patient 2
      </div>
    </div>
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" @click="$refs.slideOver.hide()" class="tw-mr-3">Cancel</base-button>
        <base-button :loading="isLoading" :disabled="!member1 || !member2" @click="mergeUsers">Merge</base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { XIcon } from "@/assets/svgs";
import MemberSearch from "@/components/MemberSearch";
import { mapGetters } from "vuex";

export default {
  components: {
    MemberSearch,
    XIcon,
  },
  props: {
    businessId: { type: String, required: true },
    userId: { type: String, required: true },
  },
  data() {
    return {
      isLoading: false,
      member1: null,
      member2: null,
    };
  },
  computed: {
    ...mapGetters("location", ["location", "locations"]),
  },
  methods: {
    show(member) {
      this.member1 = member;
      this.$refs.slideOver.show();
    },
    hide() {
      this.member1 = null;
      this.member2 = null;
      this.$refs.slideOver.hide();
    },
    async mergeUsers() {
      try {
        this.isLoading = true;
        await this.$axios.post("/users/merge", {
          fromUserId: this.member1.userId,
          toUserId: this.member2.userId,
          businessId: this.businessId,
        });
        this.$router.push(`/businesses/${this.businessId}/members/${this.member2.userId}`);
        this.hide();
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Unable to merge users",
          message: "We were not able to merge these users. There may have been a connection error. Please reload the page to try again.",
          error,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
